import { API } from '../config/api';
import { DataService } from '../config/dataService/dataService';
import { ImportAssetsService } from '../config/dataService/importAssetsService';

class AssetsService {

  static ASSET_REFERENCE_ALREADY_EXISTS = 'ASSET_REFERENCE_ALREADY_EXISTS';

  static availabilityErrors = new Set([
    AssetsService.ASSET_REFERENCE_ALREADY_EXISTS,
  ])

  static async getAssetsByType({ page, search, assetTypeId, pageSize = 20, idFinalCustomer, status }) {
    const params = {
      page,
      search,
      assetType: assetTypeId,
      idFinalCustomer,
      pageSize,
      status,
    };
    const { data } = await DataService.get(API.assets.root, params);
    return {
      assets: data.assets,
      pageSize: data.pageSize,
      total: data.total,
      page,
      search,
      assetType: assetTypeId,
    };
  }

  static async getAssetById(id) {
    const { data } = await DataService.get(`${API.assets.root}${id}`);
    return {
      asset: data.asset,
    };
  }

  static async removeAsset(id) {
    const { data } = await DataService.delete(`${API.assets.root}/${id}`);
    return {
      asset: data.asset,
    };
  }

  static async createAsset(newData) {
    const { data } = await DataService.post(`${API.assets.root}`, newData);
    return {
      asset: data.asset,
    };
  }

  static async updateAsset(id, newData) {
    const { data } = await DataService.patch(`${API.assets.root}${id}/`, newData);
    return {
      asset: data.asset,
    };
  }

  static async getSchedule(id) {
    const { data } = await DataService.get(`${API.assets.root}/${id}/${API.assets.scheduleTimes}`);
    return {
      schedule: data.scheduleData,
    };
  }

  static async updateSchedule(id, newData) {
    const assetData = {
      _id: id,
      schedulingTimes: newData.schedulingTimes,
      enableSchedule: newData.enableSchedule,
    };
    const { data } = await DataService.patch(`${API.assets.root}/${id}/${API.assets.scheduleTimes}`, assetData);
    return {
      scheduleData: data.scheduleData,
    };
  }

  static async validateAssets(idAccount, assetsFile, idAssetType) {
    const { data } = await ImportAssetsService.sendFile(`${API.assets.validator}${API.assets.validate}`, {
      idAccount,
      'assets.xlsx': assetsFile,
      idAssetType,
    });
    return {
      data: data.validated_data,
    };
  }

  static async importAssetsList({ idAccount, idAuthor, assets }) {
    const { data } = await ImportAssetsService.post(`${API.assets.assetsUploader}${API.assets.save}`, {
      idAccount,
      idAuthor,
      assets,
    });

    return {
      data,
    };
  }

  static async getAssetsNearByType({ page, search, assetTypeId, pageSize = 20, longitude, latitude }) {
    const params = {
      page,
      search,
      assetType: assetTypeId,
      pageSize,
      longitude,
      latitude,
    };

    const { data } = await DataService.get(`${API.assets.root}${API.assets.near}`, params);
    return {
      assets: data.assets,
      pageSize: data.pageSize,
      total: data.total,
      page,
      search,
      assetType: assetTypeId,
    };
  }
}

export { AssetsService };
